import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import DeleteTutorialModal from "../../../components/TutorialListCard/DeleteTutorialModal";
import { handleTextVisibility } from "../../../../../../utils";
import { FaTrash } from "react-icons/fa";
import DatacodeBackground from "../../../../../../assets/images/datacodeTutorialBackground.png";
const TutorialCard = ({
  id,
  title,
  likeTutorial,
  unlikeTutorial,
  likesCount,
  userData,
  userData: { _id, userName, email, myTutorialsLibrary },
  saveToLibrary,
  unsaveFromLibrary,
  removeTutorial,
  tutorial,
  tutorial: { img, description, link, tags },
  handleTutorialList,
}) => {
  const history = useHistory();
  const [isLiked, setLiked] = useState();
  const [isSaved, setSaved] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setLiked(
      tutorial
        ? tutorial.likes &&
            tutorial.likes.find((like) => like === _id || like === userName)
        : false
    );
    setLikeCount(tutorial ? tutorial.likes && tutorial.likes.length : 0);
    setSaved(
      userData &&
        userData.myTutorialsLibrary &&
        myTutorialsLibrary.find((lib) => lib === tutorial.id)
    );
  }, [tutorial, userData]);

  const handleUnlike = () => {
    if (!userName) {
      return history.push(`/login`);
    }

    unlikeTutorial({ id, user: _id }).then((res) => {
      if (res) {
        console.log(res);
        setLiked(
          res &&
            res?.data?.likes.find((like) => like === _id || like === userName)
        );
        setLikeCount(res && res?.data?.likes.length);
        // handleTutorialList()
      }
    });
  };

  const handleLike = () => {
    if (!userName) {
      return history.push(`/login`);
    } else {
      likeTutorial({ id, user: _id }).then((res) => {
        if (res) {
          console.log(res);
          setLiked(
            res?.data?.likes.find((like) => like === _id || like === userName)
          );
          setLikeCount(res?.data?.likes.length);
          // handleTutorialList()
        }
      });
    }
  };

  const handleSaveToLibrary = () => {
    if (!userName) {
      return history.push(`/login`);
    }
    const saveItem = tutorial.id;
    saveToLibrary({ saveItem, email }).then((res) => {
      if (res) {
        setSaved(true);
      }
    });
  };

  const handleUnsaveFromLibrary = () => {
    const saveItem = tutorial.id;
    unsaveFromLibrary({ saveItem, email }).then((res) => {
      if (res) {
        setSaved(false);
      }
    });
  };

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  const handleRemoveTutorial = () => {
    removeTutorial(id).then((res) => {
      if (res && res.success) {
        console.log(res, "res");
        toggleModal(); // Close the modal after successful removal

        // Refresh the tutorial list after deletion
        if (typeof handleTutorialList === "function") {
          handleTutorialList(); // Call the parent's refresh function
          console.log("Refreshing tutorial list...");
        } else {
          console.log(
            "No handleTutorialList function available, reloading page"
          );
          window.location.reload(); // Fallback to page reload
        }
      }
    });
  };

  return (
    <>
      <div className="p-0 tutorial-card mt-md-3 mt-4 border d-none d-md-block w-100">
        <div className="row mx-0">
          <div className="col-4 px-0 mx-0 card-image">
            <Link to={`/tutorial/${id}`}>
              <img
                src={img || DatacodeBackground}
                alt="tutorial thumbnail"
                loading="lazy"
                className="tutorial-image"
                // sizes="(min-width: 1122px) 296px,(min-width: 866px) 218px,(max-width: 610px) 202px,202px"
                onError={(e) => {
                  e.preventDefault();
                  e.target.onerror = null;
                  e.target.src = DatacodeBackground;
                  e.target.classList.add("fallback-image");
                  const parent = e.target.parentNode;
                  const overlay = document.createElement("div");
                  overlay.className = "fallback-title-overlay";
                  overlay.innerHTML = `<span>${title}</span>`;
                  parent.appendChild(overlay);
                }}
              />
            </Link>
          </div>

          <div className="col-8 py-3">
            <div className="px-2">
              <Link to={`/tutorial/${id}`}>
                <h6>{`${handleTextVisibility(title, 50)}`}</h6>
              </Link>
              <div className="tags-input row m-0 ">
                <div className="col-12 p-0">
                  <div className="tags-area border-0">
                    {tags.map((tag, index) => (
                      <div className="tag ml-0" key={index}>
                        <span className="mb-0">{tag}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <p className="">{`${handleTextVisibility(description, 100)}`}</p>
            </div>
            <div className="row m-0 px-2 tech-card-footer">
              <div className="col-12 p-0 align-items-center d-flex justify-content-between">
                <div>
                  <span className="green font-weight-bold mb-1">
                    {likeCount}
                  </span>
                  {isLiked ? (
                    <i
                      onClick={() => handleUnlike()}
                      className="fas fa-heart red mx-2"
                    />
                  ) : (
                    <i
                      onClick={() => handleLike()}
                      className="far fa-heart red mx-2"
                    />
                  )}
                  <Link to={`/tutorial/${id}`}>
                    <i className="fad fa-comments-alt voilet mx-2" />
                  </Link>
                  {isSaved ? (
                    <i
                      onClick={() => handleUnsaveFromLibrary()}
                      className="fas fa-bookmark voilet mx-2"
                    />
                  ) : (
                    <i
                      onClick={() => handleSaveToLibrary()}
                      className="far fa-bookmark voilet mx-2"
                    />
                  )}
                </div>
                {/* Add Remove Tutorial Button */}
                <FaTrash
                  onClick={() => setOpenModal(true)}
                  className="cursor-pointer text-danger"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 p-0 tutorial-card mx-0 mx-md-5 mt-md-3 mt-4 d-block d-md-none border">
        <div className="row mx-0">
          <div className="col-12 px-0 card-image">
            <Link to={`/tutorial/${id}`}>
              <img
                src={img || DatacodeBackground}
                alt="tutorial thumbnail"
                loading="lazy"
                className="mx-auto text-center tutorial-image"
                sizes="(min-width: 1122px) 296px,(min-width: 866px) 218px,(max-width: 610px) 202px,202px"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = DatacodeBackground;
                  e.target.classList.add("fallback-image");
                  const parent = e.target.parentNode;
                  const overlay = document.createElement("div");
                  overlay.className = "fallback-title-overlay";
                  overlay.innerHTML = `<span>${title}</span>`;
                  parent.appendChild(overlay);
                }}
              />
            </Link>
          </div>
        </div>

        <div className="tags-input row m-0">
          <div className="col-12 p-0">
            <div className="tags-area border-0">
              {tags.map((tag, index) => (
                <div className="tag align-item-center d-flex" key={index}>
                  <span className="mb-0">{tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="px-2">
          <Link to={`/tutorial/${id}`}>
            <h6>{`${handleTextVisibility(title, 40)}`}</h6>
          </Link>
          <p className="pb-3">{`${handleTextVisibility(description, 100)}`}</p>
        </div>
        <div className="row m-0 mb-2 p-2 tech-card-footer">
          <div className="col-6 p-0 align-items-center">
            <span className="green font-weight-bold mb-1">{likeCount}</span>
            {isLiked ? (
              <i
                onClick={() => handleUnlike()}
                className="fas fa-heart red mx-2"
              />
            ) : (
              <i
                onClick={() => handleLike()}
                className="far fa-heart red mx-2"
              />
            )}
            <Link to={`/tutorial/${id}`}>
              <i className="fad fa-comments-alt voilet mx-2" />
            </Link>
            {isSaved ? (
              <i
                onClick={() => handleUnsaveFromLibrary()}
                className="fas fa-bookmark voilet mx-2"
              />
            ) : (
              <i
                onClick={() => handleSaveToLibrary()}
                className="far fa-bookmark voilet mx-2"
              />
            )}
          </div>
          <div className="col-6 text-right">
            {/* Add Remove Tutorial Button for mobile */}
            <button
              onClick={() => setOpenModal(true)}
              className="btn btn-danger btn-sm"
            >
              <i className="far fa-trash mr-1"></i> Remove
            </button>
          </div>
        </div>
      </div>

      <DeleteTutorialModal
        open={openModal}
        toggle={toggleModal}
        onSubmit={handleRemoveTutorial}
        submitButtonName={"Delete Tutorial"}
      />
    </>
  );
};

TutorialCard.defaultProps = {
  userName: "",
  email: "",
  id: "",
  likesCount: 0,
  userData: {},
  tutorial: {},
  myTutorialsLibrary: [],
  tags: [],
};

TutorialCard.propTypes = {
  userName: PropTypes.string,
  id: PropTypes.string,
  likesCount: PropTypes.number,
  userData: PropTypes.object,
  tutorial: PropTypes.object,
  myTutorialsLibrary: PropTypes.array,
  removeTutorial: PropTypes.func,
  handleTutorialList: PropTypes.func,
};

export default TutorialCard;
